import {CATALOGO} from '../../moduli/leggi';
import {eColore} from '../../skin';

/** L'indirizzo della sezione nel sito ('/casino', '/live-casino'), dal catalogo. */
export function percorsoSezione(sezione) {
  const s = CATALOGO.sezioni.find((x) => x.chiave === sezione);
  return s ? s.percorso : '/casino';
}

/**
 * La sezione del sito -> la sezione di casino-service. Casino', Live casino e
 * Crash game si chiamano uguale; la voce Virtual mostra i giochi che
 * casino-service mette in «virtualiCasino» (CASINO_SUNSHINE_SEZIONI in
 * lvc-infra: gli studi virtual e racing). Gli studi di Crash game sono
 * nella stessa variabile, sotto «crashGame».
 */
const DEL_CATALOGO = {virtual: 'virtualiCasino'};

export function sezioneDelCatalogo(sezione) {
  return DEL_CATALOGO[sezione] || sezione;
}

/** Il contrario: la sezione di casino-service -> quella del sito («virtualiCasino» -> «virtual»). */
export function sezioneDelSito(sezione) {
  const trovata = Object.keys(DEL_CATALOGO).find((k) => DEL_CATALOGO[k] === sezione);
  return trovata || sezione;
}

/** Il modulo del backoffice che vale per la lobby: Virtual e Crash game non ne hanno uno loro e usano quello del Casino'. */
export function moduloDellaLobby(sezione) {
  return sezione === 'liveCasino' ? 'liveCasino' : 'casino';
}

/** I colori propri del modulo: variabili sulla lobby, e basta (come la testata). */
export function stileColori(colori) {
  if (!colori) return undefined;
  const stile = {};
  if (eColore(colori.fondo)) stile['--lvc-bg'] = colori.fondo.trim();
  if (eColore(colori.testo)) {
    stile['--lvc-text-1'] = colori.testo.trim();
    stile['--lvc-text-2'] = 'color-mix(in srgb, ' + colori.testo.trim() + ' 72%, transparent)';
  }
  return stile;
}
